/**
 * Turn a hyphenated slug into a spaced, title-cased label: "live-content" →
 * "Live Content". Only the first letter of each segment is upcased, so the rest
 * is preserved ("iOS" stays "iOS").
 */
export function titleCaseSlug(slug: string): string {
  return slug
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
